import * as types from '../constants/ActionTypes'

export function openSnackbar(text, status = "info") {
  return {
    type: types.OPEN_SNACKBAR,
    text,
    status
  }
}

export function closeSnackbar() {
  return {
    type: types.CLOSE_SNACKBAR
  }
}